import { render } from "./genel-bakis.vue?vue&type=template&id=15d8d23e"
import script from "./genel-bakis.vue?vue&type=script&lang=js"
export * from "./genel-bakis.vue?vue&type=script&lang=js"

import exportComponent from "/home/B2BServer/b2bPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__